import React from "react";
import styled from "styled-components";
import Select from "react-select";
import { device } from "../../atoms/Utlis/media";

export const gradient = "linear-gradient(144.01deg, #ffc951 0%, #c94daa 130%)";

export const cleanPhone = (phone: string | null | undefined): string => {
  if (!phone) return "";
  const digits = String(phone).replace(/\D/g, "");
  return digits.slice(-15);
};

export const isSamePhone = (phone1?: string | null, phone2?: string | null): boolean => {
  const p1 = cleanPhone(phone1);
  const p2 = cleanPhone(phone2);
  if (!p1 || !p2) return false;
  if (p1 === p2) return true;
  if (p1.length >= 10 && p2.length >= 10) {
    return p1.slice(-10) === p2.slice(-10);
  }
  return false;
};


export const staticGifts = [
  "Framed Print 12x18",
  "Canvas Print 24x36",
  "Premium Photo Album Box",
  "Digital Copy USB Drive",
];


export const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 24px;
  font-family: Urbanist, sans-serif;
  box-sizing: border-box;
  overflow: hidden;
  background:
    radial-gradient(ellipse 70% 40% at 0% 0%, rgba(201, 77, 170, 0.06), transparent 55%),
    radial-gradient(ellipse 50% 35% at 100% 0%, rgba(255, 201, 81, 0.07), transparent 50%),
    #f4f6f9;

  @media ${device.tablet} {
    padding: 16px;
    gap: 14px;
  }
`;

export const HeaderBlock = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 18px;
  flex-shrink: 0;
`;

export const FormScrollContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding-right: 4px;
  padding-bottom: 28px;
`;

export const BackButtonIcon = styled.img`
  width: 16px;
  height: 13.8px;
  cursor: pointer;
  transition: transform 0.16s ease;

  &:hover {
    transform: translateX(-2px);
  }
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: clamp(22px, 3vw, 28px);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.03em;
  background: ${gradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const FormHero = styled.div`
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 20px;
  padding: 20px 22px;
  background: linear-gradient(
    135deg,
    rgba(255, 201, 81, 0.16) 0%,
    rgba(206, 86, 176, 0.12) 55%,
    rgba(53, 183, 200, 0.08) 100%
  );
  border: 1px solid rgba(201, 77, 170, 0.12);
  box-shadow: 0 8px 28px rgba(201, 77, 170, 0.08);

  @media ${device.tablet} {
    padding: 16px;
    border-radius: 16px;
  }
`;

export const FormHeroGlow = styled.div`
  pointer-events: none;
  position: absolute;
  top: -60px;
  right: -4%;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 201, 81, 0.28) 0%, transparent 70%);
`;

export const FormHeroRow = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  gap: 14px;
`;

export const FormBackButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.1);
  background: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  color: rgba(23, 23, 23, 0.72);
  transition: border-color 0.15s ease, color 0.15s ease, transform 0.15s ease;

  &:hover {
    border-color: rgba(201, 77, 170, 0.25);
    color: #c94daa;
    transform: translateY(-1px);
  }
`;

export const FormHeroText = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FormHeroBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  padding: 5px 11px;
  border-radius: 999px;
  background: rgba(201, 77, 170, 0.1);
  color: #c94daa;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const FormHeroSubtitle = styled.p`
  margin: 0;
  max-width: 560px;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
  color: rgba(23, 23, 23, 0.55);
`;

export const FormCard = styled.div`
  background: #ffffff;
  border: 1px solid rgba(23, 23, 23, 0.06);
  border-radius: 20px;
  padding: 22px 24px;
  box-shadow: 0 12px 32px rgba(23, 23, 23, 0.05);
  margin-bottom: 20px;
`;

export const SectionCard = styled.div`
  background: #ffffff;
  border: 1px solid rgba(23, 23, 23, 0.06);
  border-radius: 18px;
  padding: 20px 22px;
  box-shadow: 0 10px 28px rgba(23, 23, 23, 0.04);
  margin-bottom: 20px;
`;

export const CardTitle = styled.h3`
  margin: 0 0 16px 0;
  font-size: 17px;
  font-weight: 800;
  color: #171717;
  letter-spacing: -0.01em;
`;

export const SectionHeading = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
`;

export const SectionIcon = styled.div<{ $tone?: string }>`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.$tone || "#c94daa"};
  background: ${(p) => `${p.$tone || "#c94daa"}14`};
`;

export const SectionHeadingBody = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const SectionHeadingTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #171717;
  letter-spacing: -0.01em;
`;

export const SectionHeadingSub = styled.p`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.5);
  line-height: 1.4;
`;

export const RowGrid = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;

  @media ${device.tablet} {
    flex-direction: column;
    gap: 12px;
  }
`;

export const FormGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FormLabel = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #374151;
  letter-spacing: 0.01em;
`;

export const inputBaseStyles = `
  height: 42px;
  border: 1px solid rgba(23, 23, 23, 0.12);
  border-radius: 10px;
  padding: 0 12px;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #171717;
  background: #ffffff;
  outline: none;
  box-sizing: border-box;
  width: 100%;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus {
    border-color: rgba(201, 77, 170, 0.55);
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.1);
  }
`;

const StyledTextInput = styled.input`
  ${inputBaseStyles}

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type=number] {
    -moz-appearance: textfield;
  }
`;

export const TextInput = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>((props, ref) => {
  const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    if (props.type === "number") {
      e.currentTarget.blur();
    }
    if (props.onWheel) {
      props.onWheel(e);
    }
  };

  return <StyledTextInput ref={ref} {...props} onWheel={handleWheel} />;
});

export const TextAreaInput = styled.textarea`
  ${inputBaseStyles}
  height: auto;
  padding: 10px 12px;
  resize: vertical;
`;

export const DisabledInput = styled.input`
  ${inputBaseStyles}
  background: #f1f2f4;
  color: #555c65;
  border-color: rgba(23, 23, 23, 0.08);
  cursor: not-allowed;
`;

export const SelectDropdown = styled.select`
  ${inputBaseStyles}
  cursor: pointer;
`;

export const ManualCustomerCard = styled.div`
  margin-top: 18px;
  background: linear-gradient(180deg, rgba(255, 201, 81, 0.06), rgba(201, 77, 170, 0.03));
  border: 1px dashed rgba(201, 77, 170, 0.28);
  border-radius: 14px;
  padding: 16px;
`;

export const ComponentsSection = styled.div`
  background: #ffffff;
  border: 1px solid rgba(23, 23, 23, 0.06);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(23, 23, 23, 0.05);
  margin-bottom: 20px;
`;

export const ComponentsBar = styled.div`
  padding: 16px 18px 10px;
  background: transparent;
`;

export const BarTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  background: ${gradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: inline-block;
`;

export const CheckboxContainer = styled.div`
  padding: 12px 18px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CheckboxLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.06);
  background: #fafbfc;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: rgba(201, 77, 170, 0.22);
    background: #ffffff;
  }

  &:has(input:checked) {
    border-color: rgba(201, 77, 170, 0.28);
    background: linear-gradient(135deg, rgba(201, 77, 170, 0.06), rgba(255, 201, 81, 0.08));
    box-shadow: 0 6px 16px rgba(201, 77, 170, 0.08);
    color: #171717;
  }

  input {
    width: 17px;
    height: 17px;
    flex-shrink: 0;
    cursor: pointer;
    appearance: none;
    border: 1px solid rgba(23,23,23,0.28);
    border-radius: 5px;
    background: #ffffff;
    display: grid;
    place-content: center;
  }
  input::before {
    content: "";
    width: 9px;
    height: 9px;
    transform: scale(0);
    transition: transform 0.12s ease;
    clip-path: polygon(14% 44%, 0 59%, 37% 100%, 100% 18%, 84% 5%, 36% 70%);
    background: #ffffff;
  }
  input:checked { border-color: transparent; background: ${gradient}; }
  input:checked::before { transform: scale(1); }
`;

export const TableWrap = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.06);
`;

export const DetailsTable = styled.table`
  width: 100%;
  min-width: 700px;
  border-collapse: collapse;
  background: #ffffff;

  thead tr {
    background: linear-gradient(180deg, #fbfcfe 0%, #f4f6f9 100%);
    border-bottom: 1px solid rgba(23, 23, 23, 0.06);
  }
  th {
    color: #c94daa;
    font-family: Montserrat, sans-serif;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    text-align: left;
    padding: 12px 14px;
  }
  thead tr th:first-child { border-top-left-radius: 12px; }
  thead tr th:last-child  { border-top-right-radius: 12px; }
  td {
    padding: 8px 14px;
    border-bottom: 1px solid rgba(23,23,23,0.06);
    vertical-align: middle;
  }
  tbody tr:hover { background: rgba(201,77,170,0.04); }
`;

export const tableInputBase = `
  height: 36px;
  border: 1px solid rgba(23,23,23,0.12);
  border-radius: 8px;
  padding: 0 10px;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #171717;
  background: #ffffff;
  outline: none;
  box-sizing: border-box;
  width: 100%;
  transition: all 0.2s ease;
  &:focus {
    border-color: rgba(201,77,170,0.6);
    box-shadow: 0 0 0 3px rgba(201,77,170,0.1);
  }
`;

export const TableTextInput = styled.input`${tableInputBase}`;

const StyledTableNumberInput = styled.input`
  ${tableInputBase}

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type=number] {
    -moz-appearance: textfield;
  }
`;

export const TableNumberInput = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>((props, ref) => {
  const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    if (props.type === "number") {
      e.currentTarget.blur();
    }
    if (props.onWheel) {
      props.onWheel(e);
    }
  };

  return <StyledTableNumberInput ref={ref} {...props} onWheel={handleWheel} />;
});

export const TableDateInput = styled.input`${tableInputBase} cursor: pointer;`;

export const customSelectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    minHeight: '36px',
    height: '36px',
    borderRadius: '10px',
    border: state.isFocused ? '1px solid rgba(201, 77, 170, 0.6)' : '1px solid rgba(23, 23, 23, 0.12)',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(201, 77, 170, 0.1)' : 'none',
    fontSize: '13px',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 500,
    background: state.isFocused ? '#ffffff' : '#fafbfc',
    cursor: 'pointer',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease',
    "&:hover": {
      borderColor: 'rgba(201, 77, 170, 0.6)',
      background: '#ffffff',
    }
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: '0 8px',
  }),
  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    padding: '4px 8px',
    color: 'rgba(23, 23, 23, 0.48)',
  }),
  menu: (base: any) => ({
    ...base,
    zIndex: 9999,
    borderRadius: '14px',
    marginTop: '8px',
    padding: '6px',
    border: '1px solid rgba(201, 77, 170, 0.12)',
    boxShadow: '0px 18px 36px rgba(23, 23, 23, 0.14)',
    backgroundColor: '#ffffff',
  }),
  menuList: (base: any) => ({
    ...base,
    padding: 0,
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  option: (base: any, state: any) => ({
    ...base,
    fontSize: '13px',
    fontFamily: 'Montserrat, sans-serif',
    borderRadius: '10px',
    padding: '10px 12px',
    fontWeight: state.isSelected ? 700 : 500,
    cursor: 'pointer',
    background: state.isSelected
      ? 'linear-gradient(135deg, rgba(255, 201, 81, 0.18), rgba(201, 77, 170, 0.16))'
      : state.isFocused
        ? 'rgba(201, 77, 170, 0.1)'
        : '#ffffff',
    color: '#171717',
    "&:active": {
      backgroundColor: 'rgba(201, 77, 170, 0.2)'
    }
  })
};

export const formSelectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    minHeight: '42px',
    height: '42px',
    borderRadius: '12px',
    border: state.isFocused ? '1px solid rgba(201, 77, 170, 0.6)' : '1px solid rgba(23, 23, 23, 0.12)',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(201, 77, 170, 0.1)' : 'none',
    fontSize: '14px',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 500,
    background: state.isFocused ? '#ffffff' : '#fafbfc',
    cursor: 'pointer',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease',
    "&:hover": {
      borderColor: 'rgba(201, 77, 170, 0.6)',
      background: '#ffffff',
    }
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: '0 12px',
  }),
  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    padding: '4px 12px',
    color: 'rgba(23, 23, 23, 0.48)',
  }),
  menu: (base: any) => ({
    ...base,
    zIndex: 9999,
    borderRadius: '16px',
    marginTop: '8px',
    padding: '6px',
    border: '1px solid rgba(201, 77, 170, 0.12)',
    boxShadow: '0px 18px 36px rgba(23, 23, 23, 0.14)',
    backgroundColor: '#ffffff',
  }),
  menuList: (base: any) => ({
    ...base,
    padding: 0,
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  option: (base: any, state: any) => ({
    ...base,
    fontSize: '14px',
    fontFamily: 'Montserrat, sans-serif',
    borderRadius: '12px',
    padding: '11px 13px',
    fontWeight: state.isSelected ? 700 : 500,
    cursor: 'pointer',
    background: state.isSelected
      ? 'linear-gradient(135deg, rgba(255, 201, 81, 0.18), rgba(201, 77, 170, 0.16))'
      : state.isFocused
        ? 'rgba(201, 77, 170, 0.1)'
        : '#ffffff',
    color: '#171717',
    "&:active": {
      backgroundColor: 'rgba(201, 77, 170, 0.2)'
    }
  })
};

interface SelectProps {
  name?: string;
  id?: string;
  value: string | number;
  onChange: (e: { target: { name?: string; value: string } }) => void;
  children: React.ReactNode;
  disabled?: boolean;
}

export const FormSelect: React.FC<SelectProps> = ({ name, id, value, onChange, children, disabled }) => {
  const options: any[] = [];
  React.Children.forEach(children, child => {
    if (React.isValidElement<any>(child) && child.type === 'option') {
      options.push({ value: child.props.value, label: child.props.children });
    } else if (Array.isArray(child)) {
      child.forEach(c => {
        if (React.isValidElement<any>(c) && c.type === 'option') {
          options.push({ value: c.props.value, label: c.props.children });
        }
      });
    }
  });

  const selectedOption = options.find(o => String(o.value) === String(value)) || null;

  return (
    <Select
      inputId={id}
      name={name}
      value={selectedOption}
      onChange={(option: any) => onChange({ target: { name, value: option ? option.value : "" } })}
      options={options}
      styles={formSelectStyles}
      isDisabled={disabled}
      menuPosition="fixed"
      menuPortalTarget={document.body}
    />
  );
};

export const TableSelect: React.FC<SelectProps> = ({ value, onChange, children, disabled }) => {
  const options: any[] = [];
  React.Children.forEach(children, child => {
    if (React.isValidElement<any>(child) && child.type === 'option') {
      options.push({ value: child.props.value, label: child.props.children });
    } else if (Array.isArray(child)) {
      child.forEach(c => {
        if (React.isValidElement<any>(c) && c.type === 'option') {
          options.push({ value: c.props.value, label: c.props.children });
        }
      });
    }
  });

  const selectedOption = options.find(o => String(o.value) === String(value)) || null;

  return (
    <Select
      value={selectedOption}
      onChange={(option: any) => onChange({ target: { value: option ? option.value : "" } })}
      options={options}
      styles={customSelectStyles}
      isDisabled={disabled}
      menuPosition="fixed"
      menuPortalTarget={document.body}
    />
  );
};

export const ActionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const TableAddButton = styled.button`
  width: 28px; height: 28px;
  display: flex; align-items: center; justify-content: center;
  background: ${gradient};
  color: white; border: none; border-radius: 6px; cursor: pointer;
  box-shadow: 0 8px 18px rgba(201,77,170,0.22);
  &:hover { transform: translateY(-1px); }
`;

export const TableDeleteButton = styled.button`
  width: 28px; height: 28px;
  display: flex; align-items: center; justify-content: center;
  background: #ea5455;
  color: white; border: none; border-radius: 6px; cursor: pointer;
  box-shadow: 0 4px 8px rgba(234,84,85,0.2);
  &:hover { background: #e83b3d; }
`;

export const SizeX = styled.span`
  font-weight: 700;
  font-size: 14px;
  color: rgba(23,23,23,0.5);
  white-space: nowrap;
`;

export const BottomSection = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 10px;
  @media ${device.tablet} { flex-direction: column; }
`;

export const BottomColumn = styled.div`flex: 1;`;

export const GrandTotalDisplay = styled.div`
  font-size: 22px;
  font-weight: 800;
  color: #c94daa;
  padding: 10px 14px;
  background: linear-gradient(135deg, rgba(201, 77, 170, 0.08), rgba(255, 201, 81, 0.1));
  border-radius: 12px;
  border: 1px solid rgba(201, 77, 170, 0.16);
  display: inline-block;
  min-width: 180px;
`;

export const FooterButtonsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 8px;
  padding: 16px 18px;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid rgba(23, 23, 23, 0.06);
  box-shadow: 0 12px 32px rgba(23, 23, 23, 0.05);
  position: sticky;
  bottom: 12px;
  z-index: 20;

  @media ${device.tablet} {
    flex-direction: column;
    align-items: stretch;
    position: static;
  }
`;

export const SubmitHint = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.5);
  line-height: 1.4;
`;

export const SaveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 26px;
  border: none;
  border-radius: 12px;
  background: ${gradient};
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 10px 22px rgba(201, 77, 170, 0.24);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 12px 26px rgba(201, 77, 170, 0.3);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

export const BottomCheckboxes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid rgba(23,23,23,0.08);
`;

export const Req = styled.span`
  color: red;
`;

export const SectionLabel = styled.h2`
  margin: 0 0 16px 0;
  font-size: 20px;
  font-weight: 800;
  color: #171717;
`;

export const TableDatePickerWrapper = styled.div`
  width: 100%;

  .MuiFormControl-root {
    width: 100%;
    background: white;
    border-radius: 10px;
  }

  .MuiInputBase-root {
    height: 36px;
    font-family: Montserrat, sans-serif;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
  }

  .MuiOutlinedInput-notchedOutline {
    border: 1px solid rgba(23, 23, 23, 0.12) !important;
    border-radius: 10px;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgba(201, 77, 170, 0.45) !important;
  }

  .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: rgba(201, 77, 170, 0.55) !important;
    border-width: 1px !important;
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.12);
  }

  .MuiOutlinedInput-input {
    padding: 0 10px;
    height: 100%;
    cursor: pointer;
  }

  .MuiInputBase-input::placeholder {
    color: #9ca3af;
    font-size: 12px;
    opacity: 1;
  }

  .MuiIconButton-root {
    padding: 4px;
    color: #6b7280;
  }

  .MuiInputAdornment-root .MuiSvgIcon-root {
    color: #c94daa;
    font-size: 18px;
  }
`;

export const TableTimePickerWrapper = styled.div`
  width: 100%;

  .MuiFormControl-root {
    width: 100%;
    background: white;
    border-radius: 10px;
  }

  .MuiInputBase-root {
    height: 36px;
    font-family: Montserrat, sans-serif;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
  }

  .MuiOutlinedInput-notchedOutline {
    border: 1px solid rgba(23, 23, 23, 0.12) !important;
    border-radius: 10px;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgba(201, 77, 170, 0.45) !important;
  }

  .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: rgba(201, 77, 170, 0.55) !important;
    border-width: 1px !important;
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.12);
  }

  .MuiOutlinedInput-input {
    padding: 0 10px;
    height: 100%;
    cursor: pointer;
  }

  .MuiInputAdornment-root .MuiSvgIcon-root {
    color: #c94daa;
    font-size: 18px;
  }
`;

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ToggleLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #171717;
`;

export const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 24px;
  }

  span:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
  }

  input:checked + span {
    background: ${gradient};
  }

  input:checked + span:before {
    transform: translateX(20px);
  }
`;

export const WithoutPriceBanner = styled.div`
  background: linear-gradient(135deg, rgba(201, 77, 170, 0.07), rgba(255, 201, 81, 0.1));
  border: 1px solid rgba(201, 77, 170, 0.16);
  border-radius: 14px;
  padding: 14px 16px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const WithoutPriceToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const WithoutPriceText = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #171717;
  font-family: Montserrat, sans-serif;
`;

export const WithoutPriceInfoBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(201, 77, 170, 0.14);
  border-radius: 12px;
  padding: 10px 14px;
  color: rgba(23, 23, 23, 0.68);
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 1.45;
  max-width: 580px;

  svg {
    flex-shrink: 0;
  }
`;

